import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { DrwList, MpDrwList } from 'models/mp/MpDrw';
import { MpMgrChgList } from 'models/mp/MpMgr';
import { callApi } from 'utils/ApiUtil';

/**
 * MP 담당자 변경이력 조회
 * @param searchParam
 */
export const getMpMgrChgHistoryList = async (searchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getMpMgrChgHistoryList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<MpMgrChgList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpMgrChgList[];
};
